import React, { useState } from 'react';
import Header from '../components/site/Header';
import Navigation from '../components/site/Navigation';
import Sidebar from '../components/site/Sidebar';
import HeroBanner from '../components/site/HeroBanner';
import LogoMarquee from '../components/site/LogoMarquee';
import GameCards from '../components/site/GameCards';
import Promotions from '../components/site/Promotions';
import FeatureCards from '../components/site/FeatureCards';
import Products from '../components/site/Products';
import ExchangeListings from '../components/site/ExchangeListings';
import DealingTerms from '../components/site/DealingTerms';
import PaymentsWeAccept from '../components/site/PaymentsWeAccept';
import Originals from '../components/site/Originals';
import InPlay from '../components/site/InPlay';
import TopRated from '../components/site/TopRated';
import CricketLoader from '../components/site/CricketLoader';
import RightSidebar from '../components/site/RightSidebar';
import FloatingSocial from '../components/site/FloatingSocial';
import Footer from '../components/site/Footer';
import LoginModal from '../components/site/LoginModal';
import SignupModal from '../components/site/SignupModal';
import MobileMenu from '../components/site/MobileMenu';
import EnquiryModal from '../components/site/EnquiryModal';
import FlyerAdModal from '../components/site/FlyerAdModal';
import SearchResultsBar from '../components/site/SearchResultsBar';
import { useSite } from '../context/SiteContext';

const DEFAULT_SECTION_ORDER = [
  'hero',
  'marquee',
  'gamecards',
  'promotions',
  'features',
  'products',
  'exchanges',
  'dealingTerms',
  'paymentsWeAccept',
  'topRated',
  'originals',
  'inplay'
];

export default function Home() {
  const { data } = useSite();
  const sv = data.sectionVisibility || {};
  const show = (k) => sv[k] !== false;
  const [loginOpen, setLoginOpen] = useState(false);
  const [signupOpen, setSignupOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [enquiryOpen, setEnquiryOpen] = useState(false);
  const [enquiryContext, setEnquiryContext] = useState(null);

  const openEnquiry = (product, item) => {
    setEnquiryContext({ product, item });
    setEnquiryOpen(true);
  };

  const rawOrder = Array.isArray(data.sectionOrder) && data.sectionOrder.length > 0
    ? data.sectionOrder
    : DEFAULT_SECTION_ORDER;

  const effectiveOrder = [
    ...rawOrder.filter(k => DEFAULT_SECTION_ORDER.includes(k)),
    ...DEFAULT_SECTION_ORDER.filter(k => !rawOrder.includes(k))
  ];

  const renderSection = (key) => {
    if (sv[key] === false) return null;

    switch (key) {
      case 'hero':
        return <HeroBanner key="hero" />;
      case 'marquee':
        return <LogoMarquee key="marquee" />;
      case 'gamecards':
        return <GameCards key="gamecards" onEnquire={openEnquiry} />;
      case 'promotions':
        return <div key="promotions" id="promotions"><Promotions /></div>;
      case 'features':
        return <div key="features" id="features"><FeatureCards /></div>;
      case 'products':
        return <div key="products" id="products"><Products onEnquire={openEnquiry} /></div>;
      case 'exchanges':
        return <div key="exchanges" id="exchanges"><ExchangeListings /></div>;
      case 'dealingTerms':
        return <div key="dealingTerms" id="dealingTerms"><DealingTerms /></div>;
      case 'paymentsWeAccept':
        return <div key="paymentsWeAccept" id="paymentsWeAccept"><PaymentsWeAccept /></div>;
      case 'topRated':
        return <div key="topRated" id="topRated"><TopRated /></div>;
      case 'originals':
        return <div key="originals" id="platforms"><Originals /></div>;
      case 'inplay':
        return <div key="inplay" id="inplay"><InPlay onEnquire={openEnquiry} /></div>;
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen" style={{ background: data.branding.pageBg }}>
      <CricketLoader />
      <div className="sticky top-0 z-40 w-full shadow-md">
        <Header
          onLogin={() => setLoginOpen(true)}
          onRegister={() => setSignupOpen(true)}
          onMobileMenu={() => setMobileMenuOpen(true)}
        />
        <Navigation />
        <SearchResultsBar />
      </div>

      <div className="max-w-[1400px] mx-auto px-2 md:px-4 mt-3 md:mt-4">
        <div className="grid grid-cols-12 gap-3">
          <aside className="hidden lg:block lg:col-span-2">
            <div className="sticky top-[120px] max-h-[calc(100vh-130px)] overflow-y-auto overscroll-contain no-scrollbar">
              <Sidebar />
            </div>
          </aside>

          <main className="col-span-12 lg:col-span-7 space-y-4">
            {effectiveOrder.map((key) => renderSection(key))}
          </main>

          {show('rightSidebar') && (
            <aside className="hidden lg:block lg:col-span-3">
              <div className="sticky top-[120px] max-h-[calc(100vh-130px)] overflow-y-auto overscroll-contain no-scrollbar">
                <RightSidebar onLogin={() => setLoginOpen(true)} />
              </div>
            </aside>
          )}
        </div>
      </div>

      <Footer />
      {show('floatingSocial') && <FloatingSocial />}

      <LoginModal
        open={loginOpen}
        onOpenChange={setLoginOpen}
        onSwitchToSignup={() => { setLoginOpen(false); setSignupOpen(true); }}
      />
      <SignupModal
        open={signupOpen}
        onOpenChange={setSignupOpen}
        onSwitchToLogin={() => { setSignupOpen(false); setLoginOpen(true); }}
      />
      <MobileMenu
        open={mobileMenuOpen}
        onOpenChange={setMobileMenuOpen}
        onLogin={() => { setMobileMenuOpen(false); setLoginOpen(true); }}
        onRegister={() => { setMobileMenuOpen(false); setSignupOpen(true); }}
      />
      <EnquiryModal
        open={enquiryOpen}
        onOpenChange={setEnquiryOpen}
        context={enquiryContext}
      />
      <FlyerAdModal />
    </div>
  );
}
